import { PaidDomainsApiClient } from '@fourthwall/services/dist/PaidDomainsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export type RegisterPaidDomainRequestBody = Parameters<
  typeof PaidDomainsApiClient.registerPaidDomain
>[number]

export const useRegisterPaidDomainMutation = createMutationHook(
  PaidDomainsApiClient.registerPaidDomain,
  {
    mutationKey: ['registerPaidDomain'],
  },
)
